// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media print {
    body {
        margin: 0 !important;
    }
}

.main-container {
    --ckeditor5-preview-sidebar-width: 294px;
    --ckeditor5-preview-height: 777px;
    font-family: 'Lato';
    margin-left: auto;
    margin-right: auto;
}

.ck-content {
    font-family: 'Lato';
    line-height: 1.6;
    word-break: break-word;
}

.editor-container__editor-wrapper {
    width: 100%;
    display: flex;
    /*width: fit-content;*/
}

.editor-container_document-editor {
    border: 1px solid var(--ck-color-base-border);
}

.editor-container_document-editor .editor-container__toolbar {
    display: flex;
    position: relative;
    box-shadow: 0 2px 3px hsla(0, 0%, 0%, 0.078);
}

.editor-container_document-editor .editor-container__toolbar > .ck.ck-toolbar {
    flex-grow: 1;
    width: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}

.editor-container_document-editor .editor-container__menu-bar > .ck.ck-menu-bar {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
    border-top: 0;
    border-left: 0;
    border-right: 0;
}

.editor-container_document-editor .editor-container__editor-wrapper {
    max-height: var(--ckeditor5-preview-height);
    min-height: var(--ckeditor5-preview-height);
    overflow-y: scroll;
    background: var(--ck-color-base-foreground);
}

.editor-container_document-editor .editor-container__editor {
    display: flex;
    justify-content: center;
    width: 100%;
    margin-top: 28px;
    margin-bottom: 28px;
    height: 100%;
}

.editor-container_document-editor .editor-container__editor .ck.ck-editor__editable {
    box-sizing: border-box;
    min-width: 215.9mm;
    max-width: 215.9mm;
    min-height: 279.4mm;
    height: fit-content;
    padding: 3mm 4mm;
    border: 1px hsl(0, 0%, 82.7%) solid;
    background: hsl(0, 0%, 100%);
    box-shadow: 0 2px 3px hsla(0, 0%, 0%, 0.078);
    flex: 1 1 auto;
    margin-left: auto;
    margin-right: auto;
}


.editor-container__sidebar {
    min-width: var(--ckeditor5-preview-sidebar-width);
    max-width: var(--ckeditor5-preview-sidebar-width);
    margin-top: 28px;
    margin-left: 10px;
    margin-right: 10px;
}

.editor-container__minimap-wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
}

.editor-container__sidebar_minimap {
    margin: 0;
    flex: 0 0 auto;
    border-left: 1px solid var(--ck-color-toolbar-border);
    position: relative;
    overflow: hidden;
    max-height: 100%;
}

.editor-container_include-minimap.ck-minimap__iframe-content {
    background: hsl(0, 0%, 100%);
}

.editor-container_include-minimap.ck-minimap__iframe-content .ck.ck-editor__editable {
    font-family: 'Lato';
    line-height: 1.15;
    flex: 1 1 auto;
    word-break: break-word;
    box-sizing: border-box;
    min-width: 215.9mm;
    max-width: 215.9mm;
    min-height: 279.4mm;
    height: fit-content;
    padding: 3mm 4mm;
}

.editor-container_include-minimap .editor-container__editor-wrapper {
    height: 100%;
}

.editor-container_include-minimap .editor-container__sidebar_minimap {
    max-width: calc(var(--ckeditor5-preview-sidebar-width) / 2);
    min-width: calc(var(--ckeditor5-preview-sidebar-width) / 2);
}

.ck-content {
    font-family: 'Lato', sans-serif;
    line-height: 1.15;
    word-break: break-word;
}

.ck-content p {
    margin: 0 0 8pt;
}

.editor-container__sidebar_minimap {
    overflow: visible !important;
    height: auto !important;
    max-height: 100% !important;
    width: 100% !important;
}`, "",{"version":3,"sources":["webpack://./src/components/certificatesEditor/certificates.css"],"names":[],"mappings":"AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,wCAAwC;IACxC,iCAAiC;IACjC,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,QAAQ;IACR,6BAA6B;IAC7B,4BAA4B;IAC5B,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,6BAA6B;IAC7B,4BAA4B;IAC5B,aAAa;IACb,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2CAA2C;IAC3C,2CAA2C;IAC3C,kBAAkB;IAClB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,4CAA4C;IAC5C,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;;AAGA;IACI,iDAAiD;IACjD,iDAAiD;IACjD,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,qDAAqD;IACrD,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,2DAA2D;IAC3D,2DAA2D;AAC/D;;AAEA;IACI,+BAA+B;IAC/B,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,4BAA4B;IAC5B,uBAAuB;IACvB,2BAA2B;IAC3B,sBAAsB;AAC1B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,400;0,700;1,400;1,700&display=swap');\r\n\r\n@media print {\r\n    body {\r\n        margin: 0 !important;\r\n    }\r\n}\r\n\r\n.main-container {\r\n    --ckeditor5-preview-sidebar-width: 294px;\r\n    --ckeditor5-preview-height: 777px;\r\n    font-family: 'Lato';\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n.ck-content {\r\n    font-family: 'Lato';\r\n    line-height: 1.6;\r\n    word-break: break-word;\r\n}\r\n\r\n.editor-container__editor-wrapper {\r\n    width: 100%;\r\n    display: flex;\r\n    /*width: fit-content;*/\r\n}\r\n\r\n.editor-container_document-editor {\r\n    border: 1px solid var(--ck-color-base-border);\r\n}\r\n\r\n.editor-container_document-editor .editor-container__toolbar {\r\n    display: flex;\r\n    position: relative;\r\n    box-shadow: 0 2px 3px hsla(0, 0%, 0%, 0.078);\r\n}\r\n\r\n.editor-container_document-editor .editor-container__toolbar > .ck.ck-toolbar {\r\n    flex-grow: 1;\r\n    width: 0;\r\n    border-bottom-right-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-top: 0;\r\n    border-left: 0;\r\n    border-right: 0;\r\n}\r\n\r\n.editor-container_document-editor .editor-container__menu-bar > .ck.ck-menu-bar {\r\n    border-bottom-right-radius: 0;\r\n    border-bottom-left-radius: 0;\r\n    border-top: 0;\r\n    border-left: 0;\r\n    border-right: 0;\r\n}\r\n\r\n.editor-container_document-editor .editor-container__editor-wrapper {\r\n    max-height: var(--ckeditor5-preview-height);\r\n    min-height: var(--ckeditor5-preview-height);\r\n    overflow-y: scroll;\r\n    background: var(--ck-color-base-foreground);\r\n}\r\n\r\n.editor-container_document-editor .editor-container__editor {\r\n    display: flex;\r\n    justify-content: center;\r\n    width: 100%;\r\n    margin-top: 28px;\r\n    margin-bottom: 28px;\r\n    height: 100%;\r\n}\r\n\r\n.editor-container_document-editor .editor-container__editor .ck.ck-editor__editable {\r\n    box-sizing: border-box;\r\n    min-width: 215.9mm;\r\n    max-width: 215.9mm;\r\n    min-height: 279.4mm;\r\n    height: fit-content;\r\n    padding: 3mm 4mm;\r\n    border: 1px hsl(0, 0%, 82.7%) solid;\r\n    background: hsl(0, 0%, 100%);\r\n    box-shadow: 0 2px 3px hsla(0, 0%, 0%, 0.078);\r\n    flex: 1 1 auto;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n\r\n\r\n.editor-container__sidebar {\r\n    min-width: var(--ckeditor5-preview-sidebar-width);\r\n    max-width: var(--ckeditor5-preview-sidebar-width);\r\n    margin-top: 28px;\r\n    margin-left: 10px;\r\n    margin-right: 10px;\r\n}\r\n\r\n.editor-container__minimap-wrapper {\r\n    display: flex;\r\n    flex-direction: row;\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n.editor-container__sidebar_minimap {\r\n    margin: 0;\r\n    flex: 0 0 auto;\r\n    border-left: 1px solid var(--ck-color-toolbar-border);\r\n    position: relative;\r\n    overflow: hidden;\r\n    max-height: 100%;\r\n}\r\n\r\n.editor-container_include-minimap.ck-minimap__iframe-content {\r\n    background: hsl(0, 0%, 100%);\r\n}\r\n\r\n.editor-container_include-minimap.ck-minimap__iframe-content .ck.ck-editor__editable {\r\n    font-family: 'Lato';\r\n    line-height: 1.15;\r\n    flex: 1 1 auto;\r\n    word-break: break-word;\r\n    box-sizing: border-box;\r\n    min-width: 215.9mm;\r\n    max-width: 215.9mm;\r\n    min-height: 279.4mm;\r\n    height: fit-content;\r\n    padding: 3mm 4mm;\r\n}\r\n\r\n.editor-container_include-minimap .editor-container__editor-wrapper {\r\n    height: 100%;\r\n}\r\n\r\n.editor-container_include-minimap .editor-container__sidebar_minimap {\r\n    max-width: calc(var(--ckeditor5-preview-sidebar-width) / 2);\r\n    min-width: calc(var(--ckeditor5-preview-sidebar-width) / 2);\r\n}\r\n\r\n.ck-content {\r\n    font-family: 'Lato', sans-serif;\r\n    line-height: 1.15;\r\n    word-break: break-word;\r\n}\r\n\r\n.ck-content p {\r\n    margin: 0 0 8pt;\r\n}\r\n\r\n.editor-container__sidebar_minimap {\r\n    overflow: visible !important;\r\n    height: auto !important;\r\n    max-height: 100% !important;\r\n    width: 100% !important;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
